import '../css/app.css';
import '../css/custom.css';
import 'lenis/dist/lenis.css';
//import './bootstrap';
import 'alpinejs/dist/cdn'
import { createInertiaApp, Link } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import VueClickAway from "vue3-click-away";
import VueTheMask from 'vue-the-mask'
import Layout from './Layout/base.vue'
import PhosphorIcons from "@phosphor-icons/vue"
import { createPinia } from 'pinia'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
AOS.init();


const appName = import.meta.env.VITE_APP_NAME || 'Laravel';
const pinia = createPinia();
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: name => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')).then((page) => {
        page.default.layout = page.default.layout || Layout
        return page
    }),

    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .component('Link',Link)
            .use(plugin)
            .use(ZiggyVue)
            .use(pinia)
            .use(VueClickAway)
            .use(VueTheMask)
            .use(PhosphorIcons)
            .use(VuePlyr, {
                plyr: {}
            })
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
